import { PropTypes } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import { isUsOnly, routerPush } from '../../../../../../../utils';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import { getLoginPayload, setLoyaltyLocation } from '../../../../../../../constants/analytics';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/SimplifiedHeader.style';
import BagPageSelectors from '../../../../BagPage/container/BagPage.selectors';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../../../utils/labels/labelUtilty';
import BAGPAGE_LABELS from '../../../../BagPage/container/Bagpage.labels';
import { getIsInternationalShipping } from '../../../../../../../reduxStore/selectors/session.selectors';

const onLinkClick = (e) => {
  const { pathname = 'referrer' } = (window && window.location) || {};
  e.preventDefault();
  routerPush(`/home?target=login&successtarget=${pathname}`, '/home/login');
};

const SimplifiedHeader = ({
  className,
  estimatedRewards,
  earnedRewards,
  IsInternationalShipping,
}) => {
  const rewardVal = earnedRewards ? earnedRewards.split(' ')?.[0] : '';
  const headerTitleText = rewardVal
    ? getDynamicLabelValues('dynamic.cart.lbl_bag_simplified_rewards_text')
    : getDynamicLabelValues('dynamic.cart.lbl_bag_simplified_points_text');
  const pointsSection = `<span class="simplified-mpr-plcc-theme">${
    rewardVal || estimatedRewards
  }</span>`;
  const rewardsDesc = headerTitleText?.replace('#estimatedRewards', pointsSection);

  return (
    <div className={` ${className} simplified-bag-header`}>
      <BodyCopy
        fontFamily="secondary"
        fontSize={['fs12', 'fs15', 'fs15']}
        color="black"
        fontWeight="bold"
        component="span"
        data-locator="pickup-title"
        onClick={onLinkClick}
        className="cta-link"
      >
        <ClickTracker
          as="span"
          onClick={() => {
            setLoyaltyLocation('cart');
          }}
          clickData={getLoginPayload('cart')}
        >
          {getLabelFromCopyOrFromTranslation(
            'checkout.bagPage.lbl_signin_cta_banner_signin',
            BAGPAGE_LABELS
          )}
        </ClickTracker>
      </BodyCopy>
      {isUsOnly() && estimatedRewards > 0 && !IsInternationalShipping ? (
        <BodyCopy
          className="bag-simplified-text"
          fontFamily="secondary"
          fontSize={['fs12', 'fs15', 'fs15']}
          color="black"
          component="span"
          dangerouslySetInnerHTML={{ __html: rewardsDesc }}
        />
      ) : (
        <BodyCopy
          className="bag-simplified-text"
          fontFamily="secondary"
          fontSize={['fs12', 'fs15', 'fs15']}
          component="span"
          color="black"
        >
          {getDynamicLabelValues('dynamic.cart.lbl_bag_simplified_generic_text')}
        </BodyCopy>
      )}
    </div>
  );
};

SimplifiedHeader.propTypes = {
  className: PropTypes.string,
  estimatedRewards: PropTypes.number,
};

SimplifiedHeader.defaultProps = {
  className: '',
  estimatedRewards: 0,
};

const mapStateToProps = (state) => {
  return {
    estimatedRewards: BagPageSelectors.getOrdertTotalPoints(state),
    earnedRewards: BagPageSelectors.getOrdertTotalRewards(state),
    IsInternationalShipping: getIsInternationalShipping(state),
  };
};

export default connect(mapStateToProps)(withStyles(SimplifiedHeader, styles));
export { SimplifiedHeader as SimplifiedHeaderVanilla };
